const VWOConfig = {
    vwoVariant: 'program_upsell_vwo_variant',
    listExperimentId: ['grow1520_variant_A', 'grow1520_variant_B'],
};

export default VWOConfig;
